import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, inrShort } from "../../lib/api";
import { PageHead } from "../../components/ui-bits";
import { BarChart, Bar, PieChart, Pie, Cell, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { UsersThree, Briefcase, Ticket, CurrencyInr, Headset, ArrowUpRight, Warning } from "@phosphor-icons/react";

const PIE = ["#002FA7", "#00A86B", "#111111", "#FFD700"];
const tip = { contentStyle: { background: "#111", border: "none", borderRadius: 2, color: "#fff", fontSize: 12 } };

export default function AdminOverview() {
  const [stats, setStats] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);
  if (!stats) return <p className="label">Loading…</p>;

  const cards = [
    { label: "Total Clients", value: stats.total_clients, Icon: UsersThree, to: "/admin/clients", testid: "ov-clients" },
    { label: "Agents", value: stats.total_agents, Icon: Headset, to: "/admin/agents", testid: "ov-agents" },
    { label: "Active Projects", value: stats.active_projects, Icon: Briefcase, to: "/admin/tasks", testid: "ov-projects" },
    { label: "Open Tickets", value: stats.open_tickets, Icon: Ticket, to: "/admin/tickets", testid: "ov-tickets" },
    { label: "Jobs at Risk", value: stats.sla_at_risk ?? 0, Icon: Warning, to: "/admin/reports", testid: "ov-risk", warn: (stats.sla_at_risk ?? 0) > 0 },
    { label: "MRR", value: inrShort(stats.mrr), Icon: CurrencyInr, to: "/admin/clients", testid: "ov-mrr" },
  ];

  return (
    <div>
      <PageHead eyebrow="Performance & Revenue" title="Overview" />
      <div className="grid grid-cols-2 lg:grid-cols-6 gap-4 mb-6">
        {cards.map((c, i) => (
          <button key={i} data-testid={c.testid} onClick={() => navigate(c.to)}
            className="card p-5 text-left group hover:border-[#002FA7] hover:-translate-y-0.5 transition-all">
            <div className="flex items-center justify-between mb-3">
              <c.Icon size={22} className={c.warn ? "text-[#FF3B30]" : "text-[#002FA7]"} />
              <ArrowUpRight size={16} className="text-[#bbb] group-hover:text-[#002FA7] transition-colors" />
            </div>
            <p className="label mb-1">{c.label}</p>
            <p className={`font-head font-black text-2xl tnum ${c.warn ? "text-[#FF3B30]" : ""}`}>{c.value}</p>
          </button>
        ))}
      </div>
      <div className="grid lg:grid-cols-3 gap-4">
        <div className="card p-6 lg:col-span-2">
          <p className="label mb-4">Revenue Trend (₹ '000)</p>
          <ResponsiveContainer width="100%" height={240}>
            <BarChart data={stats.revenue_trend}>
              <CartesianGrid strokeDasharray="2 2" vertical={false} stroke="#eee" />
              <XAxis dataKey="month" tick={{ fontSize: 12 }} /><YAxis tick={{ fontSize: 12 }} />
              <Tooltip {...tip} /><Bar dataKey="revenue" fill="#002FA7" />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="card p-6">
          <p className="label mb-4">Plan Split</p>
          <ResponsiveContainer width="100%" height={240}>
            <PieChart>
              <Pie data={stats.plan_split} dataKey="value" nameKey="name" innerRadius={40} outerRadius={75} label={({ name }) => name}>
                {stats.plan_split.map((e, i) => <Cell key={i} fill={PIE[i % PIE.length]} />)}
              </Pie>
              <Tooltip {...tip} />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
